export const LocationData = {
  stores: [
    {
      name: "DS Nutrition",
      address: "18529 N Scottsdale Rd, Scottsdale AZ 85255",
      stockDays: "Sundays and Wednesdays",
    },
    {
      name: "Firebird Nutrition",
      address: "2966 Hayden Rd, Scottsdale AZ 85251",
      stockDays: "Wednesdays",
    },
    {
      name: "Rexius Nutrition",
      address: "101 E Southern Ave, Tempe AZ 85282",
      stockDays: "Wednesdays",
    },
    {
      name: "Liberty Pump Nutrition",
      address: "454 N Lindsay Rd Ste A3, Mesa AZ 85213",
      stockDays: "Mondays",
    },
  ],
  gyms: [
    {
      name: "Hive Fit Club",
      address: "8275 N Pima Rd, Scottsdale AZ 85258",
      stockDays: "Sundays and Wednesdays",
    },
    {
      name: "The Collective",
      address: "3150 E Ray Rd #126, Gilbert AZ 85296",
      stockDays: "Sundays",
    },
    {
      name: "TG Phoenix",
      address: "3901 E Thunderbird Rd, Phoenix AZ 85032",
      stockDays: "Sundays and Wednesdays",
    },
    {
      name: "Barbell Effect Training Facility",
      address: "3535 W Southern Ave #130, Phoenix AZ 85041",
      stockDays: "Mondays",
    },
  ],
  vendingMachines: [
    {
      name: "Track Club Fitness",
      address: "915 N Central Ave, Phoenix AZ 85004",
      stockDays: "Sundays and Wednesdays",
      locationUrl:
        "https://menu.bytetechnology.co/menu?id=x26SVsH9YjAgyYNWRr553g",
    },
    {
      name: "Tangible Wellness",
      address: "1500 E Thomas Rd Ste 110, Phoenix AZ 85014",
      stockDays: "Sundays and Wednesdays",
      locationUrl:
        "https://menu.bytetechnology.co/menu?id=nDpdja5nihQ143A30Klc0w",
    },
    {
      name: "Trifit Wellness ",
      address: "505 E Camelback Rd, Phoenix AZ 85012",
      stockDays: "Sundays and Wednesdays",
      locationUrl:
        "https://menu.bytetechnology.co/menu?id=lZmxFzEFHA7lAM8VLmV6Lg",
    },
    {
      name: "The Fitness Vault",
      address: "560 Brown Rd, Mesa AZ 85201",
      stockDays: "Sundays and Wednesdays",
      locationUrl:
        "https://menu.bytetechnology.co/menu?id=XajgG6i8XjOqceMDa5BCoQ",
    },
    {
      name: "Die Trying Tempe",
      address: "1828 E University Dr, Tempe AZ 85288",
      stockDays: "Sundays and Wednesdays",
      locationUrl:
        "https://menu.bytetechnology.co/menu?id=G-jx6a35RYOApNqLAQznSg",
    },
    {
      name: "Muscletopia USA",
      address: "3302 N 24th St. #101, Phoenix AZ 85016",
      stockDays: "Sundays and Wednesdays",
      locationUrl:
        "https://menu.bytetechnology.co/menu?id=gdCEZfAPhaqUUycK7m5_8w",
    },
    {
      name: "Digital Realty",
      address: "2121 S Price Rd, Chandler AZ 85286",
      stockDays: "Sundays",
      locationUrl:
        "https://menu.bytetechnology.co/menu?id=owQpQm6LQkjT3LgZn2YFPA",
    },
  ],
};
